var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.61179V4.90295C4 4.40427 4.39796 4 4.88887 4H19.1109C19.6017 4 19.9996 4.40421 19.9997 4.90286L20 7.61179M4 7.61179H20M4 7.61179L9.91168 12.7592C10.1087 12.9308 10.2221 13.1812 10.2221 13.4447V19.0966C10.2221 19.684 10.7656 20.1151 11.3265 19.9726L13.1043 19.5211C13.5 19.4206 13.7776 19.0594 13.7776 18.6451V13.4448C13.7776 13.1812 13.8909 12.9308 14.088 12.7592L20 7.61179",
    strokeOpacity: 0.65,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d756e3c6ba47f8d6af873efd269e0ef4.svg";
export { ForwardRef as ReactComponent };